import Vue from "vue";
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";

/**
 * 注册确认弹窗（可注入 el-dialog 属性与 DialogFooter 配置）
 *
 * @param {Object} options
 * @param {String} options.title 标题
 * @param {String} options.msg 内容
 * @param {String} options.btnText 取消按钮文案（与 AlertTipsDialog 保持一致）
 * @param {String} options.confirmText 确认按钮文案
 * @param {Boolean} options.needCancel 是否展示双按钮
 * @param {Function} options.callBack 点击取消按钮回调
 * @param {Function} options.callCancelBack 点击确认按钮回调
 * @param {String} options.showType 显示类型('NB/SH等')
 * @param {Object} options.dialogOptions 透传给 el-dialog 的属性（width/top/等）
 * @param {Object} options.footerProps DialogFooter 相关配置（confirmText/cancelText/reverse/confirmOptions/cancelOptions/attrs）
 */
ConfirmDialog.install = function (options) {
    const ConfirmBox = Vue.extend(ConfirmDialog);
    let instance = new ConfirmBox();

    const id = "confirm-dialog";
    const el = document.createElement("div");
    el.id = id;
    document.body.appendChild(el);

    instance.$mount(`#${id}`);

    Vue.nextTick(() => {
        instance.open(options);
    });
};

export default ConfirmDialog;

